import React from 'react';
import { FullBar, ProgressBar } from './styled';

export interface LoadingBarProps {
  percentComplete: number;
}

export const LoadingBar = ({ percentComplete }: LoadingBarProps): React.JSX.Element => {
  return (
    <FullBar>
      <ProgressBar percentComplete={percentComplete} />
    </FullBar>
  );
};
